import { DEFAULT_PILLS } from 'components/pages/Home/HomePills';

/**
 * Fetches the HomePills JSON from S3 (NEXT_PUBLIC_HOME_PILLS_CONFIG_URL) and
 * returns { serverHomePills, serverHomePillsTitle }. Falls back to DEFAULT_PILLS
 * when the env var is absent, the request fails, or the response is empty.
 *
 * Extracted from pages/index.js so all timeline pages can reuse the same logic.
 */
export const fetchHomePills = async () => {
  const url = process.env.NEXT_PUBLIC_HOME_PILLS_CONFIG_URL;
  if (!url)
    return { serverHomePills: DEFAULT_PILLS, serverHomePillsTitle: null };

  return fetch(url)
    .then((r) => r.json())
    .then((d) => {
      const filtered = filterAndSortPills(d.stores ?? []);
      return {
        serverHomePills: filtered.length ? filtered : DEFAULT_PILLS,
        serverHomePillsTitle: d.title?.trim() || null,
      };
    })
    .catch(() => ({
      serverHomePills: DEFAULT_PILLS,
      serverHomePillsTitle: null,
    }));
};

export const isValidPill = (entry) =>
  Boolean(entry?.url?.trim() && (entry.logo?.trim() || entry.text?.trim()));

export const filterAndSortPills = (entries, now = new Date()) => {
  const ts = now instanceof Date ? now.getTime() : new Date(now).getTime();

  return entries
    .filter((entry) => {
      if (!isValidPill(entry)) return false;
      if (entry.starts_at && new Date(entry.starts_at).getTime() > ts)
        return false;
      if (entry.ends_at && new Date(entry.ends_at).getTime() <= ts)
        return false;
      return true;
    })
    .sort((a, b) => {
      const aHasDate = Boolean(a.starts_at);
      const bHasDate = Boolean(b.starts_at);
      if (aHasDate && !bHasDate) return -1;
      if (!aHasDate && bHasDate) return 1;
      if (!aHasDate && !bHasDate) return 0;
      return new Date(b.starts_at).getTime() - new Date(a.starts_at).getTime();
    });
};
